import { request } from './service'

// 获取当前用户信息
export function getUserProfile() {
  return request({ url: '/system/user/user_info/', method: 'get' })
}

// 更新用户信息（name, email, avatar, gender）
export function updateUserProfile(data) {
  return request({ url: '/system/user/update_user_info/', method: 'put', data })
}

// 修改密码
export function changePassword(userId, data) {
  return request({ url: `/system/user/${userId}/change_password/`, method: 'put', data })
}

// 获取对话历史列表（分页）
export function getChatHistory(params) {
  return request({ url: '/user/userstalk/', method: 'get', params })
}
